import type { Membership } from "@albertine/types";
import type { UpdateMemberMembershipRequest } from "@albertine/types/openapi";

type MembershipWithFirestoreFields = Membership & {
    createdAt?: unknown;
    updatedAt?: unknown;
};

export function toUpdateMemberMembershipRequest(
    membership: Membership,
): UpdateMemberMembershipRequest["membership"] {
    const {
        cancellation,
        createdAt: _createdAt,
        updatedAt: _updatedAt,
        ...rest
    } = membership as MembershipWithFirestoreFields;

    return {
        ...rest,
        cancellation: cancellation
            ? {
                  reason: cancellation.reason,
                  cancelledBy: cancellation.cancelledBy,
                  additionalNote: cancellation.additionalNote ?? null,
              }
            : cancellation,
    };
}
